import React from "react";
import companyLogo from "../../../../../assets/images/brands/AES-logo.svg";
import "../../../../Employee/EmployeeDetails/style.css";
const PayslipCard = ({ emp }) => {
  const totalEarnings = emp.earnings.reduce((a, b) => a + b.amount, 0);
  const totalDeductions = emp.deductions.reduce((a, b) => a + b.amount, 0);
  const netPay = totalEarnings - totalDeductions;

  const maxRows = Math.max(emp.earnings.length, emp.deductions.length);
    function numberToWords(num) {
        num = Math.floor(Number(num));

        num = num.toString().replace(/,/g, "");
        let [rupees, paise] = num.split(".");
        rupees = parseInt(rupees || 0);
        paise = parseInt(paise || 0);

        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

        function convertBelowThousand(n) {
            let str = "";
            if (n > 99) { str += ones[Math.floor(n / 100)] + " Hundred "; n = n % 100; }
            if (n > 0) { if (n < 20) { str += ones[n] + " "; } else { str += tens[Math.floor(n / 10)] + " " + ones[n % 10] + " "; } }
            return str.trim();
        }

        function convertNumber(num) {
            let result = "";
            const crore = Math.floor(num / 10000000);
            num %= 10000000;
            const lakh = Math.floor(num / 100000);
            num %= 100000;
            const thousand = Math.floor(num / 1000);
            num %= 1000;

            const remainder = num;

            if (crore) result += convertBelowThousand(crore) + " Crore ";
            if (lakh) result += convertBelowThousand(lakh) + " Lakh ";
            if (thousand) result += convertBelowThousand(thousand) + " Thousand ";
            if (remainder) result += convertBelowThousand(remainder);

            return result.trim();
        }

        let words = convertNumber(rupees) + " Rupees";
        if (paise > 0) { words += " and " + convertBelowThousand(paise) + " Paise"; }

        return words + " Only";
    }

  return (
      <div className="payslip-container">
          <div className="company-header">
              <div className="logo-section">
                  <img src={companyLogo} alt="Company Logo" />
              </div>

              <div className="company-details">
                  <h2><b>{emp.company_name || "AES Technologie Private Limited"}</b></h2>
                  <p>{emp.company_address || "G N Mills, Coimbatore - 641029, India"}</p>
                  <h5 className="salary-title w-100 text-end">Salary for the month of {emp.salary_date}  </h5>
              </div>
          </div>

          <div className="summary">
                <div>
                    <p><strong>CODE:</strong> {emp.emp_no}</p>
                    <p><strong>NAME:</strong> {emp.emp_name}</p>
                    <p><strong>DESIGNATION:</strong> {emp.designation}</p>
                    <p><strong>DOJ:</strong> {emp.doj}</p>
                </div>
                <div>
                    <p><strong>PAN:</strong> {emp.pf_no}</p>                    
                    <p><strong>UAN:</strong> {emp.uan_no}</p>
                    <p><strong>ACCOUNT NO:</strong> {emp.bank_acc_no}</p>
                    <p><strong>BANK NAME:</strong> {emp.bank_name}</p>
                </div>
                <div>
                    <p>PAID DAYS: {emp.paid_days}</p>
                    <p>ABSENT: {emp.lop_days}</p>
                    <p>WEEKOFF: {emp.week_off}</p>
                    <p>HOLIDAY: {emp.holidays}</p>
                </div>
          </div>

         <table className="table-bordered border-dark bg-white">
              <thead className="border border-light">
                  <tr>
                      <th className="border border-secondary">EARNINGS</th>
                      <th className="border border-secondary">AMOUNT</th>
                      <th className="border border-secondary">DEDUCTIONS</th>
                      <th className="border border-secondary">AMOUNT</th>
                  </tr>
              </thead>
              <tbody>
                  {[...Array(maxRows)].map((_, index) => (
                      <tr key={index}>
                          <td>{emp.earnings[index]?.variable || ""}</td>
                          <td>
                              {emp.earnings[index]
                                  ? `₹ ${emp.earnings[index].amount.toLocaleString()}`
                                  : ""}
                          </td>
                          <td>{emp.deductions[index]?.variable || ""}</td>
                          <td>
                              {emp.deductions[index]
                                  ? `₹ ${emp.deductions[index].amount.toLocaleString()}`
                                  : ""}
                          </td>
                      </tr>
                  ))}

                <tr className="fw-bold">
                      <td>GROSS</td>
                      <td>₹ {totalEarnings.toLocaleString()}</td>
                      <td>DEDUCTIONS</td>
                      <td>₹ {totalDeductions.toLocaleString()}</td>
                  </tr>
              </tbody>
          </table>

          <div className="final-net">
              TOTAL NET PAYABLE: ₹ {netPay.toLocaleString()}
          </div>
          <p className="fw-bold mt-2 text-end">Amount in Words: {numberToWords(Number(netPay))}</p>
          <div className="payslip-footer text-center mt-4">
              <hr />
              <p className="mb-0 fw-semibold">
                  ** This is a system-generated payslip and does not require any signature. **
              </p>
          </div>
      </div>
  );
};

export default PayslipCard;